import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { google_api_key } from "../../utility/Common";

const MapWithMarkers = () => {
  // Center of the map
  const mapCenter = { lat: 23.3441, lng: 85.3096 }; // Example: Ranchi

  // Array of marker data
  const markers = [
    { id: 1, position: { lat: 23.3441, lng: 85.3096 } }, // Ranchi
    { id: 2, position: { lat: 23.4067, lng: 85.3216 } }, // Kanke
    { id: 3, position: { lat: 23.4342, lng: 84.6796 } }, // Lohardaga
    { id: 4, position: { lat: 23.0427, lng: 84.5406 } }, // Gumla
    { id: 5, position: { lat: 23.0791, lng: 85.2791 } }, // Khunti
    { id: 6, position: { lat: 23.6342, lng: 85.5191 } }, // Ramgarh
  ];

  // Map container style
  const mapContainerStyle = {
    width: "100%",
    height: "500px",
  };

  return (
    <LoadScript googleMapsApiKey={google_api_key}>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={mapCenter}
        zoom={6}
      >
        {markers.map((marker) => (
          <Marker key={marker.id} position={marker.position} />
        ))}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapWithMarkers;
